export default __webpack_public_path__ + "static/media/regulatory--no-atvs--g1.351b1213.png";